import React from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import { Images } from "config/images";
import Chart from "./Components/Chart";
import { formatCash } from "config/constant";
import ImagesConfig from "components/ImagesConfig";

const BannerLoyalty = props => {
	const classes = useStyles();
	const {
		handleInfoLoyaltyDefault,
		properties,
		currentSales = 0,
		achivedSales = 0,
		dataInfoLoyalty,
		nextLevel,
		levelAchieved = false,
		currentLevel,
		isInfo = false,
		details
	} = props;

	const percent =
		currentSales / achivedSales > 1
			? 100
			: (currentSales / achivedSales) * 100;

	const moneyLeftOver =
		achivedSales - currentSales > 0
			? achivedSales - (details ? 0 : currentSales)
			: 0;

	const isLocal = window.location.host === "localhost:3000";

	return (
		<Grid
			classes={{ root: classes.backgroundBanner }}
			style={{
				background:
					properties?.backgroundColor ||
					"linear-gradient(106.14deg, #EBC793 2.33%, #D79475 95.45%)"
			}}
		>
			{isInfo && (
				<Grid
					classes={{ root: classes.btnInfo }}
					onClick={() => handleInfoLoyaltyDefault()}
				>
					<img src={Images.icInfoWhite} alt="icInfoWhite" />
				</Grid>
			)}
			<Grid classes={{ root: classes.rootBanner }}>
				<Grid classes={{ root: classes.left }}>
					<Grid style={{ paddingBottom: details ? 10 : 0 }}>
						<Grid classes={{ root: classes.title }}>
							Doanh số hiện tại (Đ)
						</Grid>
						{!details && (
							<Grid classes={{ root: classes.titlePrice }}>
								<img src={Images.icDollar} alt={"icDollar"} />
								{formatCash(currentSales)}
							</Grid>
						)}
					</Grid>
					<Chart
						progress={details ? 0 : percent}
						level={1}
						dataInfoLoyalty={dataInfoLoyalty}
						levelAchieved={levelAchieved}
						nextLevel={nextLevel || properties?.level}
						currentLevel={currentLevel}
					/>
					<Grid classes={{ root: classes.centerItem }}>
						<Grid
							classes={{ root: classes.bannerSales }}
							style={{
								background: properties?.backgroundSales
							}}
						>
							Đạt doanh số {formatCash(achivedSales)}
						</Grid>
					</Grid>
				</Grid>
				<Grid
					classes={{ root: classes.right }}
					style={{
						display: "flex",
						justifyContent: "center"
					}}
				>
					<Grid>
						<Grid classes={{ root: classes.centerItem }}>
							<ImagesConfig
								image={
									isLocal
										? `https://sb-shop.kido.vn${properties?.logo}`
										: properties?.logo
								}
								width={58}
								height={58}
								imageDefault={Images.icCopperLevel1}
							/>
						</Grid>
						<Grid
							classes={{ root: classes.bannerBonus }}
							style={{
								background: properties?.backgroundPercent
							}}
						>
							Thưởng {properties?.rewardLevel}%
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				classes={{ root: classes.footerBanner }}
				style={{
					background: properties?.backgroundFooter
				}}
			>
				{!details && (
					<React.Fragment>
						Bạn còn <span>{formatCash(moneyLeftOver)}</span> để đạt
						hạng{" "}
						<span>{dataInfoLoyalty[nextLevel]?.levelName}</span>
					</React.Fragment>
				)}
			</Grid>
		</Grid>
	);
};

export default BannerLoyalty;
